import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ViewFormTable } from '../models/view-form.model';
import { Location } from '@angular/common';

@Component({
  selector: 'app-view-form',
  templateUrl: './view-form.component.html',
  styleUrls: ['./view-form.component.scss']
})
export class ViewFormComponent<T> implements OnInit {

  @Input() data:T = {} as T;
  @Input() formData: ViewFormTable[] = [];

  constructor(
    private location: Location
  ) { }

  ngOnInit() {
  }
  

  getValue(key: string): any {
    const value = this.data ? (this.data as Record<string, any>)[key] : '';
    return value?.toString();
  }

  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.data = changes['data'].currentValue;
    }
    if (changes['formData']) {
      this.formData = changes['formData'].currentValue;
    }
  }

  getOption(item:ViewFormTable):Record<string,any>{
    const value = this.getValue(item.key);
    var option = item.options?.find(op => +op['id'] == +value);
    return  option ?? {};
  }
  
  back() {
    this.location.back();
  }
}
